var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGames(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 38,
    viewBox: "0 0 30 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23438 30.6523H5.72266V31.6289H4.74609V31.1406H4.25781V30.6523H2.30469V31.1406H1.81641V35.0469H2.30469V35.5352H4.25781V35.0469H4.74609V33.582H3.28125V32.6055H5.72266V35.5352H5.23438V36.0234H4.74609V36.5117H1.81641V36.0234H1.32812V35.5352H0.839844V30.6523H1.32812V30.1641H1.81641V29.6758H4.74609V30.1641H5.23438V30.6523ZM7.67578 33.582H10.6055V32.1172H10.1172V31.6289H9.62891V31.1406H8.65234V31.6289H8.16406V32.1172H7.67578V33.582ZM7.67578 36.5117H6.69922V31.6289H7.1875V31.1406H7.67578V30.6523H8.16406V30.1641H8.65234V29.6758H9.62891V30.1641H10.1172V30.6523H10.6055V31.1406H11.0938V31.6289H11.582V36.5117H10.6055V34.5586H7.67578V36.5117ZM13.5352 36.5117H12.5586V29.6758H13.5352V30.6523H14.0234V31.1406H14.5117V31.6289H15.4883V31.1406H15.9766V30.6523H16.4648V29.6758H17.4414V36.5117H16.4648V32.1172H15.9766V32.6055H15.4883V33.582H14.5117V32.6055H14.0234V32.1172H13.5352V36.5117ZM23.3008 29.6758V30.6523H19.3945V32.6055H22.3242V33.582H19.3945V35.5352H23.3008V36.5117H18.418V29.6758H23.3008ZM28.6719 30.6523H29.1602V31.6289H28.1836V31.1406H27.6953V30.6523H25.7422V31.1406H25.2539V32.1172H25.7422V32.6055H28.1836V33.0938H28.6719V33.582H29.1602V35.5352H28.6719V36.0234H28.1836V36.5117H25.2539V36.0234H24.7656V35.5352H24.2773V34.5586H25.2539V35.0469H25.7422V35.5352H27.6953V35.0469H28.1836V34.0703H27.6953V33.582H25.2539V33.0938H24.7656V32.6055H24.2773V30.6523H24.7656V30.1641H25.2539V29.6758H28.1836V30.1641H28.6719V30.6523Z",
    fill: "#3DD22B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1391 23.4295V22.2895H18.4191V21.142H20.7066V20.002H22.9941V18.8545H24.1341V17.7145H25.2816V6.28453H24.1341V5.14453H22.9941V6.28453H20.7066V7.43203H18.4191V8.57203H16.1391V9.71203H13.8516V10.8595H14.9953V22.2895H13.8553V23.4295H16.1391ZM20.7066 9.71203H22.9941V10.8595H20.7066V9.71203ZM17.2791 16.5745H19.5703V18.8545H17.2828L17.2791 16.5745Z",
    fill: "#3DD22B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9984 4.00391H20.7109V5.14391H22.9984V4.00391Z",
    fill: "#3DD22B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7094 2.85938H18.4219V4.00688H20.7094V2.85938Z",
    fill: "#3DD22B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4206 1.71875H16.1406V2.85875H18.4206V1.71875Z",
    fill: "#3DD22B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1391 5.14453H13.8516V7.43203H16.1391V5.14453Z",
    fill: "#3DD22B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1391 0.570312H13.8516V1.71781H16.1391V0.570312Z",
    fill: "#3DD22B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.85 21.1445H11.5625V22.292H13.85V21.1445Z",
    fill: "#3DD22B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.85 8.57422H11.5625V9.71422H13.85V8.57422Z",
    fill: "#3DD22B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.85 1.71875H11.5625V2.85875H13.85V1.71875Z",
    fill: "#3DD22B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13.85 16.5742H11.5625V18.8542H13.85V16.5742Z",
    fill: "#3DD22B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.85 12H11.5625V14.2875H13.85V12Z",
    fill: "#3DD22B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5688 20.0039H9.28125V21.1439H11.5688V20.0039Z",
    fill: "#3DD22B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5688 7.43359H9.28125V8.57359H11.5688V7.43359Z",
    fill: "#3DD22B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5688 2.85938H9.28125V4.00688H11.5688V2.85938Z",
    fill: "#3DD22B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28 18.8555H7V20.003H9.28V18.8555Z",
    fill: "#3DD22B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28 6.28516H7V7.43266H9.28V6.28516Z",
    fill: "#3DD22B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28 4.00391H7V5.14391H9.28V4.00391Z",
    fill: "#3DD22B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28 14.2891H7V16.5766H9.28V14.2891Z",
    fill: "#3DD22B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28 9.71094H7V11.9984H9.28V9.71094Z",
    fill: "#3DD22B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99906 17.7148H5.85156V18.8548H6.99906V17.7148Z",
    fill: "#3DD22B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99906 5.14453H5.85156V6.28453H6.99906V5.14453Z",
    fill: "#3DD22B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85094 6.28516H4.71094V17.7152H5.85094V6.28516Z",
    fill: "#3DD22B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGames);
export default __webpack_public_path__ + "static/media/games.ef2873d94fd5d497c0ea07c1100c617c.svg";
export { ForwardRef as ReactComponent };